/* ==========================================================================
   Coquille Chamber of Commerce — Member Directory Filter & Search
   ========================================================================== */

(function () {
  'use strict';

  var container = document.querySelector('[data-coquille-directory]');
  if (!container) return;

  var categorySelect = container.querySelector('[data-filter-category]');
  var searchInput = container.querySelector('[data-filter-search]');
  var resetBtn = container.querySelector('[data-filter-reset]');
  var cards = container.querySelectorAll('[data-member-card]');
  var noResults = container.querySelector('[data-no-results]');

  function filterCards() {
    var selectedCategory = categorySelect ? categorySelect.value : '';
    var query = searchInput ? searchInput.value.toLowerCase().trim() : '';
    var visibleCount = 0;

    cards.forEach(function (card) {
      var category = card.getAttribute('data-category') || '';
      var name = card.getAttribute('data-name') || '';
      var address = card.getAttribute('data-address') || '';

      var matchesCategory = !selectedCategory || category === selectedCategory;
      var matchesSearch = !query ||
        name.toLowerCase().indexOf(query) !== -1 ||
        address.toLowerCase().indexOf(query) !== -1 ||
        category.toLowerCase().indexOf(query) !== -1;

      if (matchesCategory && matchesSearch) {
        card.style.display = '';
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    });

    if (noResults) {
      if (visibleCount === 0) {
        noResults.classList.add('is-visible');
      } else {
        noResults.classList.remove('is-visible');
      }
    }
  }

  if (categorySelect) {
    categorySelect.addEventListener('change', filterCards);
  }
  if (searchInput) {
    searchInput.addEventListener('input', filterCards);
  }
  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      if (categorySelect) categorySelect.value = '';
      if (searchInput) searchInput.value = '';
      filterCards();
    });
  }
})();

/* ==========================================================================
   Header "More" overflow button — click-to-toggle
   Shown on viewports too narrow for full nav but wider than mobile breakpoint.
   The Horizon theme's hover activation does not reveal [part="overflow"],
   so we toggle it ourselves via a data attribute on <overflow-list>.
   ========================================================================== */

(function () {
  'use strict';

  /** @param {Element | null} [except] */
  function closeAll(except) {
    document.querySelectorAll('overflow-list[data-more-open]').forEach(function (ol) {
      if (ol !== except) ol.removeAttribute('data-more-open');
    });
  }

  document.addEventListener('click', function (e) {
    if (!(e.target instanceof Element)) return;

    var moreSlot = e.target.closest('[slot="more"]');

    if (moreSlot) {
      e.preventDefault();
      var overflowList = moreSlot.closest('overflow-list');
      if (!overflowList) return;
      var wasOpen = overflowList.hasAttribute('data-more-open');
      closeAll(overflowList);
      if (wasOpen) {
        overflowList.removeAttribute('data-more-open');
      } else {
        overflowList.setAttribute('data-more-open', '');
      }
      return;
    }

    // Click inside the open overflow panel: let links work normally, then close
    if (e.target.closest('[slot="overflow"]')) {
      closeAll();
      return;
    }

    // Outside click — close all open overflow panels
    closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });
})();

/* ==========================================================================
   Scroll-reveal observer (Riverdays + any future pages)
   ========================================================================== */

(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var targets = document.querySelectorAll('.coquille-rd-section, .coquille-rd-sponsor, .coquille-rd-vendor');
  if (!targets.length) return;
  document.body.classList.add('js-reveal');
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -50px 0px' });
  targets.forEach(function (el) { observer.observe(el); });
})();
